import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityFeed = ({ activities = [], className = "" }) => {
  // Mock data if none provided
  const mockActivities = [
    {
      id: 1,
      type: 'symptom',
      title: 'Logged Symptoms',
      description: 'Headache, Fatigue - Severity: 6/10',
      timestamp: '2025-08-24T10:30:00',
      icon: 'AlertCircle',
      color: 'text-warning'
    },
    {
      id: 2,
      type: 'game',
      title: 'Reaction Time Test',
      description: 'Score: 87% - Improved by 5%',
      timestamp: '2025-08-24T09:15:00',
      icon: 'Gamepad2',
      color: 'text-success'
    },
    {
      id: 3,
      type: 'symptom',
      title: 'Logged Symptoms',
      description: 'Memory Issues - Severity: 4/10',
      timestamp: '2025-08-23T16:45:00',
      icon: 'AlertCircle',
      color: 'text-primary'
    },
    {
      id: 4,
      type: 'game',
      title: 'Memory Challenge',
      description: 'Score: 92% - New personal best!',
      timestamp: '2025-08-23T14:20:00',
      icon: 'Brain',
      color: 'text-success'
    },
    {
      id: 5,
      type: 'symptom',
      title: 'Logged Symptoms',
      description: 'Dizziness, Coordination - Severity: 3/10',
      timestamp: '2025-08-22T11:10:00',
      icon: 'AlertCircle',
      color: 'text-success'
    }
  ];

  const activityList = activities?.length > 0 ? activities : mockActivities;

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays === 1) return 'Yesterday';
    if (diffInDays < 7) return `${diffInDays} days ago`;
    
    return date?.toLocaleDateString();
  };

  const getActivityIcon = (type) => {
    switch (type) {
      case 'symptom': return 'AlertCircle';
      case 'game': return 'Gamepad2';
      case 'memory': return 'Brain';
      default: return 'Activity';
    }
  };

  return (
    <div className={`bg-card border border-border rounded-lg p-6 ${className}`}>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Activity" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
            <p className="text-sm text-muted-foreground">Your latest health entries</p>
          </div>
        </div>
      </div>
      <div className="space-y-4">
        {activityList?.map((activity, index) => (
          <div key={activity?.id} className="flex items-start space-x-4">
            {/* Timeline indicator */}
            <div className="relative flex-shrink-0">
              <div className={`w-10 h-10 rounded-full bg-muted flex items-center justify-center ${activity?.color}`}>
                <Icon name={getActivityIcon(activity?.type)} size={16} />
              </div>
              {index < activityList?.length - 1 && (
                <div className="absolute top-10 left-1/2 transform -translate-x-1/2 w-px h-6 bg-border"></div>
              )}
            </div>

            {/* Activity content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <h4 className="text-sm font-medium text-foreground">{activity?.title}</h4>
                <span className="text-xs text-muted-foreground">
                  {formatTimestamp(activity?.timestamp)}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mt-1">{activity?.description}</p>
            </div>
          </div>
        ))}
      </div>
      {activityList?.length === 0 && (
        <div className="text-center py-8">
          <Icon name="Calendar" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
          <p className="text-muted-foreground">No recent activity</p>
          <p className="text-sm text-muted-foreground mt-1">Start logging symptoms or playing games to see your activity here</p>
        </div>
      )}
    </div>
  );
};

export default RecentActivityFeed;